import React, { useState } from "react";
import { Container, Row } from "react-bootstrap";
import "../styles/login.css";
import { useDispatch } from "react-redux";
import urlBackEnd from "../services/authServices";
import axios from "axios";
import { addUser, changeStatus } from "../app/userSlice";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import ReCAPTCHA from "react-google-recaptcha";
import eyeOpen from "../img/eye_visible.ico";
import eyeClosed from "../img/eye_slash.ico";

var qs = require("qs");
const cookies = new Cookies();

function Login() {
  const [password, setPassword] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [email, setEmail] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordShow, setPasswordShow] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleRecaptchaChange = (value) => {
    setIsVerified(true);
  };

  const handlePasswordShow = () => {
    setPasswordShow(!passwordShow);
    const passwordInput = document.getElementById("exampleInputPassword1");
    const toggleIcon = document.getElementById("idIcon");
    if (passwordShow) {
      passwordInput.type = "text";
      toggleIcon.src = eyeClosed;
      console.log(passwordShow);
    } else {
      passwordInput.type = "password";
      toggleIcon.src = eyeOpen
      console.log(passwordShow);
    }
  };
  const handleValidation = () => {
    let formIsValid = true;
    if (!email.match(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/)) {
      formIsValid = false;
      setEmailError("Email No Valido");
    } else {
      setEmailError("");
    }
    if (!password.match(/^((?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9]).{8,})\S$/)) {
      formIsValid = false;
      setPasswordError(
        "Minimo 8 caracteres, que uno sea una mayuscula,que contenga numeros y letras"
      );
    } else {
      setPasswordError("");
    }
    return formIsValid;
  };
  const handleSubmit = async () => {
    const dataValid = handleValidation();
    let userData = {};

    if (!dataValid) {
      alert("Datos Incompletos, verifique password y email.");
    } else if (!isVerified) {
      // Check if reCAPTCHA is verified
      alert("Por favor complete desafio reCAPTCHA.");
    } else {
      const userSend = {
        email: email,
        password: password,
      };
      let config = {
        method: "POST",
        url: urlBackEnd.authUrl,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: qs.stringify(userSend),
      };
      try {
        const response = await axios(config);
        userData = response.data;
        console.log(userData);
        dispatch(addUser(userData));
        dispatch(changeStatus(true));
        cookies.set("token", userData.token, { path: "/" });
        cookies.set("cookie_sesion", userData.name, { path: "/" });
        navigate("/UserSpace");
      } catch (error) {
        alert(`Este es el error : ${error}`);
        console.log(error);
      }
    }
  };
  return (
    <Container className="card" id="mainContainer">
      <div className="form-floating" id="loginform">
        <h3>
          <b>Nicolas Muñoz Salcedo</b>
        </h3>
        <div className="form-group">
          <label>Email address</label>
          <input
            type="email"
            className="form-control"
            id="EmailInput"
            name="EmailInput"
            aria-describedby="emailHelp"
            placeholder="Enter email"
            onChange={(event) => setEmail(event.target.value)}
          />
          <small id="emailHelp" className="text-danger form-text">
            {emailError}
          </small>
        </div>
        <div className="password-container">
          <label>Password</label>
          <input
            type="password"
            className="form-control"
            id="exampleInputPassword1"
            placeholder="Password"
            onChange={(event) => setPassword(event.target.value)}
          />
          <span className="toggle-password" onClick={handlePasswordShow}>
            <img id="idIcon" src={eyeOpen} alt="Mostrar/ocultar contraseña" width="20" />
          </span>
          <small id="passworderror" className="text-danger form-text">
            {passwordError}
          </small>
        </div>
        <ReCAPTCHA
          sitekey="6LfejS4oAAAAANPW_qXxoFtx6NkXsEaRWgPnD6B3"
          onChange={handleRecaptchaChange}
        />
        <input
          value="Enviar"
          type="submit"
          className="btn btn-primary"
          onClick={handleSubmit}
        />
      </div>
    </Container>
  );
}
export default Login;
